import { render, staticRenderFns } from "./ChatsStatusTable.vue?vue&type=template&id=a06c3982&scoped=true&"
import script from "./ChatsStatusTable.vue?vue&type=script&lang=js&"
export * from "./ChatsStatusTable.vue?vue&type=script&lang=js&"
import style0 from "./ChatsStatusTable.vue?vue&type=style&index=0&id=a06c3982&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a06c3982",
  null
  
)

export default component.exports